import ReactSelector from "./CommonReactSelector";
import { components } from "react-select";
import translations from "./Translations";
import {
  AssignScopeTabs,
  currentUserCanUseGroups,
} from "../task/GroupAssignParts";

const Placeholder = (props) => <components.Placeholder {...props} />;

export default function AssigneePicker({
  scope,
  onScopeChange,
  langMode,
  fieldAgent = [],
  groupOptions = [],
  userValue,
  onUserChange,
  groupValue,
  groupLabel,
  onGroupChange,
  selectorHeight = "46px",
  label,
  userPlaceholder,
  groupPlaceholder,
}) {
  const canUseGroups = currentUserCanUseGroups();
  const assignLabel = label ?? translations[langMode]?.assignTo ?? "Assign To";

  return (
    <div className="flex flex-col gap-1.5 w-full">
      <label className="block text-sm font-semibold text-gray-900 dark:text-white">
        {assignLabel}
      </label>
      {canUseGroups && (
        <AssignScopeTabs
          scope={scope}
          onScopeChange={onScopeChange}
          langMode={langMode}
          userLabel={translations[langMode]?.userAssign?.replace(/\s*Assign$/i, "") || "User"}
          groupLabel={translations[langMode]?.groupAssign?.replace(/\s*Assign$/i, "") || "Group"}
        />
      )}
      <div className="w-full">
        {scope === "groups" && canUseGroups ? (
          <ReactSelector
            value={
              groupValue
                ? groupOptions.find((option) => option.value === groupValue)
                  || { value: groupValue, label: groupLabel || String(groupValue) }
                : null
            }
            options={groupOptions}
            isSearchable={true}
            height={selectorHeight}
            menuPlacement="bottom"
            menuPortalTarget={document.body}
            components={{ Placeholder }}
            placeholder={groupPlaceholder ?? translations[langMode]?.selectGroup ?? "Select Group"}
            onChange={onGroupChange}
            isClearable={true}
            isMulti={false}
            overflow="overlay"
          />
        ) : (
          <ReactSelector
            value={userValue}
            options={(fieldAgent || []).map((item) => ({
              value: item?.userId,
              label: item?.userName ?? item?.name,
            }))}
            isSearchable={true}
            height={selectorHeight}
            menuPlacement="bottom"
            menuPortalTarget={document.body}
            components={{ Placeholder }}
            placeholder={userPlaceholder ?? translations[langMode]?.selectFieldAget ?? "Select Field Agent"}
            onChange={onUserChange}
            isClearable={true}
            isMulti={false}
            overflow="overlay"
          />
        )}
      </div>
    </div>
  );
}

export const getRuleAssignScope = (rule) =>
  rule?.assignScope ??
  (rule?.groupId != null && rule?.groupId !== "" ? "groups" : "users");

export const emptySarRule = () => ({
  userId: null,
  groupId: null,
  assignScope: "users",
  areaCodes: [],
  active: true,
  allAreaCodes: false,
});
